import { AccountType } from "shared/constants/enums";

export const isLandlord = (accountType: AccountType): boolean =>
    accountType === AccountType.CorporateLandlord || accountType === AccountType.PrivateLandlord;
export type CommonLandlord = AccountType.CorporateLandlord | AccountType.PrivateLandlord;
